module.exports = __webpack_public_path__ + "img/gray-caret-up.acdca2ad.svg";